/**
 * @Author: DJ
 * @Date:   2022-06-02 13:55:36
 * @Last Modified by:   DJ
 * @Last Modified time: 2022-06-08 11:00:56
 */
import { createModel } from '@/store/tools';

const dataList = { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 };

const model = {
    namespace: 'operation',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getCompanyList': T('getCompanyList'),
            'getStatus': T('getStatus'),
            'getorderStatus': T('getorderStatus'),
            'getCompanyInfo': T('getCompanyInfo'),
            'getCompanyOwnAreaTree': T('getCompanyOwnAreaTree'),
            'getRaterecords': T('getRaterecords'),
            'getPromotionCompanyList': T('getPromotionCompanyList'),
            'getRiderList': T('getRiderList'),
            'getTransportDeliveryList': T('getTransportDeliveryList'),
            'getCompanyRiderList': T('getCompanyRiderList'),
            'getSmallTransportTransDetailMisServiceList': T('getSmallTransportTransDetailMisServiceList'),
        },
        actions: {
            'getCompanyList': A('getCompanyList'),
            'getStatus': A('getStatus'),
            'getorderStatus': A('getorderStatus'),
            'getCompanyInfo': A('getCompanyInfo'),
            'getCompanyOwnAreaTree': A('getCompanyOwnAreaTree'),
            'clearCompanyInfo': C('getCompanyInfo'),
            'getRaterecords': A('getRaterecords'),
            'getPromotionCompanyList': A('getPromotionCompanyList'),
            'getRiderList': A('getRiderList'),
            'getTransportDeliveryList': A('getTransportDeliveryList'),
            'getCompanyRiderList': A('getCompanyRiderList'),
            'getSmallTransportTransDetailMisServiceList': A('getSmallTransportTransDetailMisServiceList'),
        },
        sagas: {
            'getCompanyList': S('getCompanyList', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.pageCompanyInfo'),
            'getStatus': S('getStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getorderStatus': S('getorderStatus', '/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum'),
            'getCompanyInfo': S('getCompanyInfo', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.infoCompany'),
            'getCompanyOwnAreaTree': S('getCompanyOwnAreaTree', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.findTreeAreaInfoFilter'),
            'getRaterecords': S('getRaterecords', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.pageRatioSettingHistory'),
            'getPromotionCompanyList': S('getPromotionCompanyList', '/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.recommendUserList'),
            'getRiderList': S('getRiderList', '/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportRiderList'),
            'getTransportDeliveryList': S('getTransportDeliveryList', '/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.getTransportDeliveryList'),
            'getCompanyRiderList': S('getCompanyRiderList', '/?cmd=com.xqxc.api.pig.mis.biz.account.SmallTransportMisService.smallTransportRiderList'),
            'getSmallTransportTransDetailMisServiceList': S('getSmallTransportTransDetailMisServiceList', '/?cmd=com.xqxc.api.pig.mis.settle.SmallTransportTransDetailMisService.list'),
        },
        reducers: {
            'companyList': R('getCompanyList', dataList),
            'status': R('getStatus', []),
            'orderStatus': R('getorderStatus', []),
            'companyInfo': R('getCompanyInfo', { companyBaseInfo: {}, companyFinancialBaseInfo: {} }),
            'companyOwnAreaTree': R('getCompanyOwnAreaTree', []),
            'raterecords': R('getRaterecords', dataList),
            'promotionCompanyList': R('getPromotionCompanyList', dataList),
            'riderList': R('getRiderList', dataList),
            'transportDeliveryList': R('getTransportDeliveryList', dataList),
            'companyRiderList': R('getCompanyRiderList', dataList),
            'smallTransportTransDetailMisService': R('getSmallTransportTransDetailMisServiceList', dataList),
        }
    })
};
export default createModel(model);